import React, { useEffect, useState } from 'react';
import './VirtualMallPurchase.scss';
import { virtualMallPurchaseListApi } from './VirtualMallApi/api.js';
import { imgBaseurl } from '../../baseUrl/baseurl.ts';
import { X, ExternalLink } from 'lucide-react';
import { toast } from 'react-toastify';

export default function VirtualMallPurchase() {

    const [purchaseSummary, setPurchaseSummary] = useState({ total_amount: 0, total_orders: 0 });
    const [purchaseHistory, setPurchaseHistory] = useState([]);
    const [showReceiptModal, setShowReceiptModal] = useState(false);
    const [selectedReceipt, setSelectedReceipt] = useState(null);

    const getPurchaseHistory = async () => {
        try {
            const referal_id = localStorage.getItem("virtual_referal_id");
            const data = {
                referal_id: referal_id
            }
            const response = await virtualMallPurchaseListApi(data);
            if (response.status === true) { // Changed from result to status based on JSON
                console.log(response.data, "responsedatapurchaselist");
                if (!response.data || response.data.length === 0) {
                    toast.info("No purchase history found");
                    setPurchaseHistory([]);
                } else {
                    // toast.success(response.message || "Purchase history fetched successfully"); // Optional, maybe too noisy on valid load
                    setPurchaseHistory(response.data);
                    setPurchaseSummary({
                        total_amount: response.total_amount || 0, // Use API totals if available
                        total_orders: response.total_orders || 0
                    });
                }
            } else {
                toast.error(response.message || "Failed to fetch purchase history");
            }
        } catch (error) {
            const errorMsg = error.response?.data?.message || "An error occurred. Please try again.";
            console.error("Error fetching virtual mall purchase list:", error);
            toast.error(errorMsg);
        }
    }

    const handleViewReceipt = (receiptUrl, transactionId) => {
        // Encode only the path part to handle spaces in filenames
        if (!receiptUrl) return;
        const encodedUrl = imgBaseurl + encodeURI(receiptUrl);
        console.log(encodedUrl, 'dklfnldkfnd');

        setSelectedReceipt({ url: encodedUrl, transactionId });
        setShowReceiptModal(true);
    };

    const closeReceiptModal = () => {
        setShowReceiptModal(false);
        setSelectedReceipt(null);
    };

    useEffect(() => {
        getPurchaseHistory();
    }, []);

    return (
        <div className="dashboard-section">
            <h2>Purchase History</h2>
            <div className="table-section">
                <div className="table-header">
                    <h3>Your Orders</h3>
                    <div className="purchase-summary">
                        <div className="summary-item">
                            <span className="summary-label">Total Orders:</span>
                            <span className="summary-value">{purchaseSummary.total_orders || purchaseHistory.length}</span>
                        </div>
                        <div className="summary-item">
                            <span className="summary-label">Total Spent:</span>
                            <span className="summary-value">₹{Number(purchaseSummary.total_amount || purchaseHistory.reduce((sum, item) => sum + Number(item.amount), 0)).toFixed(2)}</span>
                        </div>
                    </div>
                </div>
                <div className="table-responsive">
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Order ID</th>
                                <th>Ref ID</th>
                                <th>Product</th>
                                <th>Date</th>
                                <th>Amount</th>
                                <th>Transaction ID</th>
                                <th>Status</th>
                                <th>Receipt</th>
                            </tr>
                        </thead>
                        <tbody>
                            {purchaseHistory.length > 0 ? (
                                purchaseHistory.map((order, index) => (
                                    <tr key={order.purchase_id || index}>
                                        <td>{index + 1}</td>
                                        <td>#{order.purchase_id}</td>
                                        <td>{order.vu_referal_id || 'N/A'}</td> {/* Added from JSON */}
                                        <td>Product {order.product_id}</td>
                                        <td>{new Date(order.created_at).toLocaleDateString()}</td>
                                        <td>₹{Number(order.amount).toFixed(2)}</td>
                                        <td>{order.transaction_id}</td>
                                        <td>
                                            <span className={`status-badge ${(order.purchase_status || order.payment_status || 'pending').toLowerCase()}`}>
                                                {order.purchase_status || order.payment_status || 'Pending'}
                                            </span>
                                        </td>
                                        <td>
                                            {order.purchase_receipt_image ? (
                                                <button
                                                    onClick={() => handleViewReceipt(order.purchase_receipt_image, order.transaction_id)}
                                                    className="action-icon-btn align-center"
                                                    title="View Receipt"
                                                    style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
                                                >
                                                    🧾 View
                                                </button>
                                            ) : (
                                                <span style={{ color: '#999', fontSize: '12px' }}>No Receipt</span>
                                            )}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="9" style={{ textAlign: 'center', padding: '20px' }}>No orders found</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Receipt Modal */}
            {showReceiptModal && selectedReceipt && (
                <div className="modal-overlay" onClick={closeReceiptModal}>
                    <div className="modal-content receipt-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h2>Payment Receipt</h2>
                            <button className="modal-close" onClick={closeReceiptModal}>
                                <X size={24} />
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="receipt-info-header">
                                <div className="receipt-transaction">
                                    <span className="label">Transaction ID:</span>
                                    <span className="value">{selectedReceipt.transactionId}</span>
                                </div>
                                <a
                                    href={selectedReceipt.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="web-view-link"
                                >
                                    <ExternalLink size={14} /> Full View
                                </a>
                            </div>

                        </div>
                        <div className="receipt-image-container">
                            <img src={selectedReceipt.url} alt="Payment Receipt" />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
